import { render } from "./NewsSliderSlide.vue?vue&type=template&id=e629210e"
import script from "./NewsSliderSlide.vue?vue&type=script&lang=js"
export * from "./NewsSliderSlide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__